import React, { useState, useEffect } from "react";
import { ColumnHeaderType } from "../../utils/Types.tsx";
import { Table } from "reactstrap";
import { findValue } from "../../utils/Util.tsx";
import "../../styles/TableComponent.css";
import "react-pagination-library/build/css/index.css";
import ReactPaginate from "react-paginate";
import { TABLE_SORT_ASC, TABLE_SORT_DESC } from "../../utils/Constants.tsx";
import SortIconASC from "../../assets/images/sort-icon-asc.svg";
import SortIconDESC from "../../assets/images/sort-icon-desc.svg";
import SortIcon from "../../assets/images/sort-icon.svg";

const TableComponent = ({
  data,
  filterName,
  sortBy,
  sortOrder,
  setSortOrder,
  setSortBy,
  handleSort,
  onAction,
  columnHeaders,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const handlePageClick = (event: { selected: number }) => {
    setCurrentPage(event.selected);
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = data?.slice(offset, offset + itemsPerPage);

  useEffect(() => {
    setCurrentPage(0);
  }, [data]);

  const getTableTd = (headerItem: ColumnHeaderType, item: any) => {
    return headerItem.htmlContent ? (
      <span dangerouslySetInnerHTML={{ __html: headerItem.htmlContent }}></span>
    ) : (
      <span
        className={`td-span w-100
        ${
          headerItem.classNameGetter
            ? headerItem.classNameGetter(item, headerItem.field, filterName)
            : ""
        }`}
      >
        {findValue(headerItem, item)}
      </span>
    );
  };
  const onHandleSort = (field: string) => {
    if (field === sortBy) {
      const newSortOrder =
        sortOrder === TABLE_SORT_ASC ? TABLE_SORT_DESC : TABLE_SORT_ASC;
      setSortOrder(newSortOrder);
      handleSort(field, newSortOrder);
    } else {
      setSortBy(field);
      setSortOrder(TABLE_SORT_ASC);
      handleSort(field, TABLE_SORT_ASC);
    }
  };

  return (
    <div>
      <div className="table-parent">
        <Table className="table-style">
          <thead className="sticky-header">
            <tr>
              {columnHeaders.map((headerItem: any, index: number) => (
                <th
                  key={`name-key-${index.toString()}`}
                  onClick={() =>
                    headerItem.sortable && onHandleSort(headerItem.field)
                  }
                >
                  <div className="d-flex flex-row mb-1">
                    {headerItem.name}
                    {headerItem.sortable && (
                      <div className="ms-2 text-gray-400">
                        <img
                          src={
                            sortBy !== headerItem.field
                              ? SortIcon
                              : sortBy === headerItem.field &&
                                  sortOrder === TABLE_SORT_ASC
                                ? SortIconASC
                                : SortIconDESC
                          }
                          alt="sort"
                          className={`sort-icon ${
                            sortBy === headerItem.field ? "active" : ""
                          }`}
                        />
                      </div>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentItems?.map((each: any, i: number) => {
              return (
                <tr
                  className={i % 2 === 0 ? "" : "data-background"}
                  key={`item-${i.toString()}`}
                >
                  {columnHeaders.map(
                    (headerItem: ColumnHeaderType, headerIndex: number) => (
                      <td
                        key={`td${headerItem.field}_${headerIndex}`}
                        className={`
                            ${
                              headerItem.classNameGetter
                                ? headerItem.classNameGetter(
                                    each,
                                    headerItem.field,
                                    filterName,
                                  )
                                : ""
                            }${headerItem?.clickable ? "text-red-500" : ""}
                        `}
                      >
                        <span
                          className={` ${
                            (headerItem.action ?? headerItem.actionGetter) &&
                            !headerItem.classNameGetter &&
                            headerItem?.clickable
                              ? "item-clickable"
                              : ""
                          } `}
                          onClick={() => {
                            (headerItem.action ?? headerItem.actionGetter) &&
                              headerItem.clickable &&
                              onAction(each, headerItem);
                          }}
                          style={
                            headerItem.clickable
                              ? { color: "green", textDecoration: "underline" }
                              : {}
                          }
                        >
                          {getTableTd(headerItem, each)}
                        </span>
                      </td>
                    ),
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      {data?.length > 0 && (
        <div className="d-flex">
          <div className="row-count">
            <strong>Rows Count </strong> : {currentItems?.length || ""}{" "}
            &nbsp;&nbsp;&nbsp; <strong>Total Count </strong>:{data.length}
          </div>
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={Math.ceil(data?.length / itemsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            activeLinkClassName={"underline"}
          />
        </div>
      )}
    </div>
  );
};

export default TableComponent;
